/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.factory('ErrorHandler', ($location, $q) => (function(data) {
    $location.replace();
    switch (data.status) {
        case 403: return $location.path('/403');
        case 404: return $location.path('/404');
        default: return $q.reject(data);
    }
}));

intra_module.factory('IdentityResolve', ($http, $log, AuthUser) => () => $http.get('/').success(function(data) {
    $log.info('Logged');
    return angular.extend(data, AuthUser);
}));

intra_module.factory('UserResolve', ($route, User, ErrorHandler) => () => User.get({ login: $route.current.params.login }).$promise.catch(ErrorHandler));

intra_module.factory('UserAchievementResolve', ($route, Achievement, ErrorHandler) => () => Achievement.query({ login: $route.current.params.login }, { withCredentials: true }).$promise.catch(ErrorHandler));

intra_module.factory('SessionsResolve', ($route, Session, ErrorHandler) => () => Session.query({
    role:  'students',
    login: $route.current.params.login,
    id:    $route.current.params.session_id
}).$promise.catch(ErrorHandler));

intra_module.factory('ModuleResolve', ($route, Module, ErrorHandler) => () => Module.get({
    module_id:    $route.current.params.session_id
}).$promise.catch(ErrorHandler));

intra_module.factory('ModulesResolve', ($route, Search, identity, ErrorHandler) => () => identity.$promise.then(function(me) {
    const params =
        {login: me.login};

    if ($route.current.params.term_id != null) { params.term_id = $route.current.params.term_id; }

    return Search.studentModules(params).$promise.catch(ErrorHandler);
}));

intra_module.factory('ProfSessionsResolve', ($route, Session, ErrorHandler) => () => Session.query({
    role:  'profs',
    login: $route.current.params.login,
    id:    $route.current.params.session_id
}).$promise.catch(ErrorHandler));

intra_module.factory('WallResolve', ($route, Wall) => () => Wall.get({ id: $route.current.params.id }).$promise);

intra_module.factory('TermResolve', ($route, Term, ErrorHandler) => () => Term.get({ name: $route.current.params.name }).$promise.catch(ErrorHandler));

intra_module.factory('CurrentTermsResolve', ($route, Term, ErrorHandler) => () => Term.query({ login: $route.current.params.login }).$promise.catch(ErrorHandler));

intra_module.factory('TermsResolve', ($route, Term, ErrorHandler) => () => Term.query({ login: $route.current.params.login, valid: false }).$promise.catch(ErrorHandler));

intra_module.factory('CoursesResolve', ($route, Activity, ErrorHandler) => () => Activity.getActivities({
    session_id:    $route.current.params.session_id
}).$promise.catch(ErrorHandler));

intra_module.factory('ProjectResolve', ($route, Activity, ErrorHandler) => () => Activity.getActivity({
    session_id:    $route.current.params.session_id,
    activity_id:   $route.current.params.activity_id
}).$promise.catch(ErrorHandler));

intra_module.factory('TicketsResolve', (Ticket, ErrorHandler) => () => Ticket.query().$promise.catch(ErrorHandler));

intra_module.factory('TicketResolve', (Ticket, $route, ErrorHandler) => () => Ticket.get({
    id: $route.current.params.id
}).$promise.catch(ErrorHandler));

intra_module.factory('StaticWallResolver', ($location, $route, $q, WallsService) => () => WallsService.fetchStaticWalls().then(function() {
    const check = WallsService.getStaticWalls().filter(wall => $route.current.params.wall_name === wall.name);
    if (0 === check.length) {
        $location.path('/404');
        return $q.reject({ });
    }})); // Afin d'éviter l'instanciation du controlleur

intra_module.factory('ADMAuthResolve', ($location, identity) => () => identity.$promise.then(function(me) {
    if (!Array.from(me.groups).includes('adm')) { $location.path('/403'); }
}));

//Resolve qui permet de rediriger vers la homepage de l'user si on essaye d'acceder a ses modules via l'url
intra_module.factory('RestrictionElearningResolve', ($route, $location, identity) => () => identity.$promise.then(function(me) {
    if ($route.current.params.login !== me.login) {
        $location.path(`/user/${$route.current.params.login}`);
        return;
    }
}));
